import React, { useEffect, useState } from "react";
import { InputLabel, MenuItem, SelectChangeEvent } from "@mui/material";
import MaterialSelect from "@mui/material/Select";

type SelectProps = {
  menuItems: { name: string; value: string; disabled?: boolean }[];
  onChange: (val: string) => void;
  label: string;
  id: string;
  loadValue?: string;
};
const Select = ({
  id,
  label,
  onChange,
  menuItems,
  loadValue = "",
}: SelectProps) => {
  const [value, setValue] = useState<string>(loadValue);

  useEffect(() => {
    if (loadValue !== value) {
      setValue(loadValue);
    }
  }, [loadValue]);
  const handleChange = (e: SelectChangeEvent) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };
  return (
    <>
      <InputLabel id={id} sx={{ color: "#fff" }}>
        {label}
      </InputLabel>
      <MaterialSelect
        id={id}
        label={label}
        value={value}
        sx={{
          color: "#fff",
          "& .MuiSvgIcon-root": {
            color: "white",
          },
        }}
        onChange={handleChange}
      >
        {menuItems.map(({ name, value , disabled}) => (
          <MenuItem disabled={disabled ? disabled : false} key={value} value={value}>
            {name}
          </MenuItem>
        ))}
      </MaterialSelect>
    </>
  );
};

export default Select;
